import type { HeadSortingItem } from "./DealershipListTableHead"
import { dealershipListMessages } from "./dealershipList.messages"
import { dealershipListColumns } from "./dealershipListColumns.const"

export const headSortingItems: HeadSortingItem[] = [
	{
		active: false,
		direction: "desc",
		hideLabel: false,
		id: "displayName",
		message: dealershipListMessages.name,
		width: dealershipListColumns.displayName,
	},
	{
		active: false,
		direction: "desc",
		hideLabel: false,
		id: "partnerNumber",
		message: dealershipListMessages.dealerKey,
		width: dealershipListColumns.partnerNumber,
	},
	{
		active: true,
		direction: "desc",
		hideLabel: false,
		id: "organisationFunction",
		message: dealershipListMessages.organizationType,
		width: dealershipListColumns.organisationFunction,
	},
	{
		active: false,
		direction: "desc",
		hideLabel: false,
		id: "country",
		message: dealershipListMessages.country,
		width: dealershipListColumns.country,
	},
]
